// extracted by mini-css-extract-plugin
export default {"root":"A3ecj","arrowIcon":"P39E4","callMetadata":"RLvev","callMode":"fUrI4","callModeIcon":"l10Z5","callStatus":"fkp_r","ellipsis":"ovgla","incoming":"mMgim"};